import axios from 'axios';
import qs from 'qs';
import { Notification } from 'element-ui'
import { basic } from './config.js';
const CancelToken = axios.CancelToken;
let _pendingList = [];
// 取消全部正在请求的接口
export function clearAllReq() {
  if (_pendingList.length > 0) {
    _pendingList.forEach(v => {
      v.cancel({
        config: {
          url: v.url,
        },
        message: 'Cancel Request',
      });
    });
  }
}

const instance = axios.create({
  baseURL: basic.http,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
  timeout: 6000,
});

/* axios请求拦截 */
instance.interceptors.request.use(config => {
  if (config.method === 'delete') {
    config.data = qs.stringify(config.params);
  }else if(config.method === 'post' && config.url === '/sensitive_words/importCategory'){
    config.headers['Content-Type'] = "multipart/form-data"
  }
    const t = new Date().getTime();
    config.url += config.url.includes('?') ? `&t=${t}` : `?t=${t}`;
    config.cancelToken = new CancelToken(cancel => {
      _pendingList.push({
        url: config.url,
        cancel,
        loading: !config.notLoading,
      });
    });
    config.headers.token = localStorage.getItem('token');
    // config.headers.token = '';
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

/* axios响应拦截 */
instance.interceptors.response.use(
  response => {
    // 从列表中移除请求完成的接口
    if (_pendingList.some(v => v.url === response.config.url)) {
      _pendingList = _pendingList.filter(v => v.url !== response.config.url);
    }
    const { code, msg } = response.data;
    // console.log('response----->',response)
    if (code === 1) {
      return response.data
    } else if (code === 0) {
      Notification.closeAll()
      Notification.error({
        title:'错误',
        message:msg
      })
      return Promise.reject(response.data);
    } else if (code === 401) {
      // console.log('未登录')
      Notification.error({
        title:'错误',
        message:msg
      })
    }
  },
  err => {
    // console.log('err',err.response.data)
    if(err.response.data.code !== 401){
      Notification.closeAll()
      Notification.error({
        title:'错误',
        message:err.response.data.msg
      })
    }else{
      window.location.href = window.location.origin+"/login?type=1"
      sessionStorage.clear();
    }
    return Promise.reject(err.response.data);
  }
);

const http = {
  /* get */
  get:(url,params,options) => {
    return new Promise((resolve,reject) => {
      instance.get(url,{params,...options}).then(res => {
        if(res && res.code === 1){
          resolve(res.data);
        }else{
          reject(res);
        }
      }).catch(err => {
        // reject(err);
      });
    });
  },
  /* post */
  post:(url,params,options={}) => {
    return new Promise((resolve, reject) => {
      instance.post(url, params, options).then(res => {
        // // console.log('ok--------', res)
        if(res && res.code === 1){
          resolve(res.data);
        }else{
          reject(res);
        }
      }).catch(err => {
        // // console.log('11111111111--------', err)
        reject(err);
      });
    });
  },
  /* put */
  put:(url,params,options={}) => {
    return new Promise((resolve, reject) => {
      instance.put(url, params, options).then(res => {
        if(res && res.code === 1){
          resolve(res.data);
        }else{
          reject(res);
        }
      }).catch(err => {
        reject(err);
      });
    });
  },
  /* delete */
  delete:(url,params,options={}) => {
    return new Promise((resolve,reject) => {
      instance.delete(url,{params,...options}).then(res => {
        // // console.log('delete',res)
        if(res && res.code === 1){
          resolve(res.data);
        }else{
          reject(res);
        }
      }).catch(err => {
        reject(err);
      });
    });
  },
};

export default http;
